import AboutNewHead from './AboutNewHead'
import AboutNewMiddle from './AboutNewMiddle'
import { lazy, Suspense } from 'react'

const ShuttleAppreciation = lazy(() => import('../shuttle_software/ShuttleAppreciation'));
const ShuttleItNeed = lazy(() => import('../shuttle_software/ShuttleItNeed'));
const ShuttleTeamLogo = lazy(() => import('../shuttle_software/ShuttleTeamLogo'));
const AboutNewAward = lazy(() => import('./AboutNewAward'));
const AboutNewNumber = lazy(() => import('./AboutNewNumber'));
const AboutNewSmart = lazy(() => import('./AboutNewSmart'));
const AboutNewTeam = lazy(() => import('./AboutNewTeam'));
const AboutNewVision = lazy(() => import('./AboutNewVision'));


export default function AboutNew() {
  return (
    <>
      <AboutNewHead />
      <AboutNewMiddle />

      <Suspense fallback={null}>
        <AboutNewSmart />
        <AboutNewVision />
        <AboutNewNumber />
        <ShuttleTeamLogo />
        <ShuttleAppreciation />
        <AboutNewTeam />
        <AboutNewAward />
        <ShuttleItNeed />
      </Suspense>
    </>
  )
}
